/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  ascertainContainer: {
    mb: 4,
    [theme.breakpoints.down('sm')]: {
      pb: '10rem',
    },
  },
  landlineprefix: {
    [theme.breakpoints.down('sm')]: {
      mt: '20px',
    },
  },
  nbiLandlinePrefix: {
    mt: '20px',
    [theme.breakpoints.down('sm')]: {
      mt: '20px',
    },
  },
  validateBBServiceContainer: {
    maxWidth: { xs: '100%', sm: '100%', md: 'calc(min(90%,956px))', lg: 956 },
    m: { xs: '0 auto', sm: '0 auto' },
    justifyContent: 'center',
  },
  validateService: {
    borderRadius: '10px 10px 0 0',
    boxShadow: `0px 6px 6px -3px  ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px  ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
  },
  landlineService: {
    borderRadius: '0 0 10px 10px',
    boxShadow: `0px 6px 6px -3px  ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px  ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
  },
  nbiLandlineService: {
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px  ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px  ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
  },
  bbServiceHeaderNumberContainer: {
    maxWidth: '16px!important',
  },
  bbServiceHeaderNumber: {
    color: theme.palette.primary.textColor3,
  },
  bbServiceHeaderText: {
    color: theme.palette.primary.textColor3,
  },
  requiredText: {
    color: theme.palette.secondary.asterisk,
    display: 'contents',
  },
  bbServiceRequired: {
    display: 'flex',
  },
  radioButton: {
    '& .MuiRadio-root': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.textColor3,
      },
    },
    '& .MuiRadio-root + .MuiTypography-root': {
      color: theme.palette.primary.textColor3,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400,
    },
    '& .MuiRadio-root.Mui-checked': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.buttonColor,
      },
    },
    '& .MuiRadio-root.Mui-checked + .MuiTypography-root': {
      color: theme.palette.primary.textColor3,
    },
  },
  radioButtonChecked: {
    color: theme.palette.primary.buttonColor,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  radioButtonUnChecked: {
    color: theme.palette.secondary.dark,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,

    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.dark,
    },
  },
  buttonContainer: {
    [theme.breakpoints.down('sm')]: {
      margin: '0 1px',
    },
  },
  cta: {
    borderRadius: '6.25rem',
    width: '6rem',
    minHeight: '2.375rem',
    textTransform: 'inherit',
    fontStyle: 'normal',
    cursor: 'inherit',
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
    marginTop: '1.5rem',

    [theme.breakpoints.up('sm')]: {
      marginTop: '16px',
      // marginLeft: '24px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  enableSubmitCTA: {
    marginTop: '1rem',
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,

    // padding: '5px 90px',

    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,

    // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
  },

  enableCTA: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    padding: '8px 24px',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      // boxShadow: `0px 6px 6px -3px   ${theme.palette.primary.boxShadow},0px 10px 14px 1px  ${theme.palette.primary.boxShadow}, 00px 4px 18px 3px  ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  disableSubmitCTA: {
    marginTop: '1rem',

    // padding: '5px 90px',

    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    background: theme.palette.primary.buttonInactiveColor,
    pointerEvents: 'none',
    color: theme.palette.primary.contrastText,
  },
  disableCTA: {
    padding: '8px 24px',

    border: `0.1875rem solid ${theme.palette.primary.buttonInactiveColor}`,
    background: theme.palette.primary.contrastText,
    pointerEvents: 'none',
    color: theme.palette.primary.buttonInactiveColor,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  submitCTAContainer: {
    display: 'flex',
    justifyContent: 'center',
    m: 4,
    [theme.breakpoints.down('sm')]: {
      m: '2rem 0.8rem 6rem 0.8rem',
    },
  },
  submitCTA: {
    border: `3px solid ${theme.palette.secondary.errorCTA}`,
    cursor: 'pointer',
    borderRadius: '100px',
    textTransform: 'capitalize',
    width: '6.625rem',
    fontSize: '1rem',
    background: theme.palette.secondary.errorCTA,
    color: theme.palette.secondary.contrastText,

    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      background: theme.palette.secondary.errorCTA,
      color: theme.palette.secondary.contrastText,

      boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  errorMessage: { color: theme.palette.primary.buttonColor },
  disableScheduleMove: {
    pointerEvents: 'none',
    opacity: '0.4',
  },
  gridCollapseDimension: {
    minHeight: '52px',
    padding: '17px 24px 17px 24px',
    alignItems: 'center',
  },
  gridText: {
    padding: '0px!important',
  },
  collapseContainer: {
    padding: '5px 24px 32px 24px!important',
  },
  NBIAlert: {
    margin: '15px 0 12px 0',
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.OfferSelected,
    },
  },
  NBIAlertTitle: {
    color: theme.palette.secondary.OfferSelected,
    fontSize: '14px',
    lineHeight: '22px',
    marginBottom: 0,
    padding: 0,
  },
  inputContainer: { width: { md: '92%', xs: '100%' }, maxWidth: { sm: '442px' } },
  inputTextbox: {
    '& .MuiInputLabel-root': { color: theme.palette.primary.textColor5 },
    '& .MuiFormLabel-asterisk': {
      color: theme.palette.secondary.asterisk,
    },
    marginTop: '8px',
    '& label.Mui-focused': {
      color: theme.palette.primary.buttonColor,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.primary.buttonColor,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.buttonColor,
      },
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '8px',
    },
  },
  tooltipContainer: {
    width: '10%',
    minHeight: '56px',
    margin: 'auto auto 0px',
    padding: 1,
    display: 'flex',
    alignItems: 'center',
  },
  faqContainerSuperMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '6rem',
  },
});
export default styles;
